/* eslint-disable eol-last */
/* eslint-disable space-before-function-paren */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        // Login
        {
            name: 'Login',
            path: '/login',
            component: () =>
                import ('@/pages/login'),
        },
        {
            name: 'Inter Phone Number',
            path: '/ResetPassword',
            component: () =>
                import ('@/pages/ResetPassword/EnterPhone'),
        },
        {
            name: 'Inter Code',
            path: '/enterCode',
            component: () =>
                import ('@/pages/ResetPassword/RessetCode'),
        },
        {
            name: 'Enter New Password',
            path: '/enterPass',
            component: () =>
                import ('@/pages/ResetPassword/NewPassword'),
        },
        {
            path: '/',
            meta: { requiresAuth: true },
            redirect: '/',
            component: () =>
                import ('@/views/dashboard/Index'),
            children: [
              // Home
              {
                name: 'statistics',
                path: '/',
                component: () =>
                    import ('@/views/dashboard/Dashboard'),
                meta: { requiresAuth: true },
            },
            // Start stock Routers
            // stock
            {
              name: 'stock',
              path: '/stock/list',
              component: () =>
                  import ('@/views/dashboard/products/List'),
              meta: { requiresAuth: true },
            },
            {
              name: 'AddNewProduct',
              path: '/stock/add-new-item',
              component: () =>
                  import ('@/views/dashboard/products/Form'),
              meta: { requiresAuth: true },
            },
            {
              name: 'transfer',
              path: '/transfer/list',
              component: () =>
                  import ('@/views/dashboard/transfer/List'),
              meta: { requiresAuth: true },
            },
            {
              name: 'transferForm',
              path: '/transfer/transferForm/:id?',
              component: () =>
                  import ('@/views/dashboard/transfer/Form'),
              meta: { requiresAuth: true },
            },
            // Start sales Routers
            // sales
            {
              name: 'sales',
              path: '/sales/list',
              component: () =>
                  import ('@/views/dashboard/sales/List'),
              meta: { requiresAuth: true },
            },
            {
              name: 'salesReturnForm',
              path: '/sales/return/:id?',
              component: () =>
                  import ('@/views/dashboard/sales/Form'),
              meta: { requiresAuth: true },
            },
            {
              name: 'salesForm',
              path: '/sales/salesForm/:id?',
              component: () =>
                  import ('@/views/dashboard/sales/Form'),
              meta: { requiresAuth: true },
            },
            // Start savebox Routers
            // savebox
            {
              name: 'savebox',
              path: '/savebox/list',
              component: () =>
                  import ('@/views/dashboard/savebox/List'),
              meta: { requiresAuth: true },
            },
            {
              name: 'saveboxAction',
              path: '/savebox/action',
              component: () =>
                  import ('@/views/dashboard/savebox/Action'),
              meta: { requiresAuth: true },
            },
            // Start client History Routers
            // client History
            {
              name: 'clientHistory',
              path: '/clients/clientHistory',
              component: () =>
                  import ('@/views/dashboard/clients/clientHistory/List'),
              meta: { requiresAuth: true },
            },
            // Start clients Routers
            // clients
            {
              name: 'clients',
              path: '/clients/clients',
              component: () =>
                  import ('@/views/dashboard/clients/clients/List'),
              meta: { requiresAuth: true },
            },
            {
              name: 'clientsForm',
              path: '/clients/clientsForm/:id?',
              component: () =>
                  import ('@/views/dashboard/clients/clients/Form'),
              meta: { requiresAuth: true },
            },
            // Start invoices Routers
            // invoices
            {
              name: 'invoices',
              path: '/invoices/invoices',
              component: () =>
                  import ('@/views/dashboard/invoices/invoices/List'),
              meta: { requiresAuth: true },
            },
            // Start settings Routers
            // categries
            {
              name: 'categries',
              path: '/settings/categries',
              component: () =>
                  import ('@/views/dashboard/setting/category/List'),
              meta: { requiresAuth: true },
            },
            {
              name: 'categriesForm',
              path: '/settings/categriesForm/:id?',
              component: () =>
                  import ('@/views/dashboard/setting/category/Form'),
              meta: { requiresAuth: true },
            },
            // Branches
            {
              name: 'branches',
              path: '/settings/branches',
              component: () =>
                  import ('@/views/dashboard/setting/branches/List'),
              meta: { requiresAuth: true },
            },
            {
              name: 'branchesForm',
              path: '/settings/branchesForm/:id?',
              component: () =>
                  import ('@/views/dashboard/setting/branches/Form'),
              meta: { requiresAuth: true },
            },
            // Stones
            {
              name: 'stones',
              path: '/settings/stones',
              component: () =>
                  import ('@/views/dashboard/setting/stones/List'),
              meta: { requiresAuth: true },
            },
            {
              name: 'stonesForm',
              path: '/settings/stonesForm/:id?',
              component: () =>
                  import ('@/views/dashboard/setting/stones/Form'),
              meta: { requiresAuth: true },
            },
            // employee
            {
              name: 'employees',
              path: '/settings/employees',
              component: () =>
                  import ('@/views/dashboard/setting/employee/List'),
              meta: { requiresAuth: true },
            },
            {
              name: 'employeesForm',
              path: '/settings/employeesForm/:id?',
              component: () =>
                  import ('@/views/dashboard/setting/employee/Form'),
              meta: { requiresAuth: true },
            },
            // End settings Routers
            // start options page
            {
              name: 'options',
              path: '/options',
              component: () =>
                  import ('@/views/dashboard/options/Form'),
              meta: { requiresAuth: true },
            },
            // start reseller page
            {
              name: 'reseller',
              path: '/reseller',
              component: () =>
                  import ('@/views/dashboard/ressaller/List'),
              meta: { requiresAuth: true },
            },
            {
              name: 'resellerForm',
              path: '/resellerForm/:id?',
              component: () =>
                  import ('@/views/dashboard/ressaller/Form'),
              meta: { requiresAuth: true },
            },
            // start reports page
            {
              name: 'stockReport',
              path: '/stock/Report',
              component: () =>
                  import ('@/views/dashboard/products/List'),
              meta: { requiresAuth: true },
            },
            {
              name: 'salesReport',
              path: '/sales/Report',
              component: () =>
                  import ('@/views/dashboard/sales/List'),
              meta: { requiresAuth: true },
            },
            {
              name: 'saveboxReport',
              path: '/savebox/Report',
              component: () =>
                  import ('@/views/dashboard/savebox/List'),
              meta: { requiresAuth: true },
            },
            {
              name: 'transferReport',
              path: '/transfer/Report',
              component: () =>
                  import ('@/views/dashboard/transfer/List'),
              meta: { requiresAuth: true },
            },
            {
              name: 'resellerReport',
              path: '/reseller/Report',
              component: () =>
                  import ('@/views/dashboard/ressaller/List'),
              meta: { requiresAuth: true },
            },
            {
              path: '/notAuthorized',
              name: 'notAuthorized',
              component: () =>
              import ('../pages/NotAuthorized.vue'),
            },
            { path: '*', redirect: '/login' },
          ],
        },
    ],
})

router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('token')
    if (to.meta.requiresAuth) {
        if (!token) {
            next({
                name: 'Login',
            })
        } else {
            return next()
        }
    } else {
        next()
    }
})

export default router
